module.exports = __webpack_public_path__ + "img/ep-logo-complex-bg.e291f2cc.jpg";